document.addEventListener("DOMContentLoaded", function () {
    const faqs = document.getElementsByClassName("faq-title");

    //aall faq titles contain an a tag. generate the href from the title
    for (let i = 0; i < faqs.length; i++) {
        const faq = faqs[i];
        const title = faq.innerText;
        const sectionId = title
            .toLowerCase()
            .replace(/[^a-zA-Z0-9 ]/g, "")
            .replace(/ /g, "-");

        faq.querySelector("a").setAttribute("href", `#${sectionId}`);
        //add the id to the parent accordion div
        faq.parentElement.setAttribute("id", sectionId);
    }

    //add click listener to all faqs
    for (let i = 0; i < faqs.length; i++) {
        faqs[i].addEventListener("click", function (event) {
            //prevent default link behavior
            event.preventDefault();
            //scroll to the top of the clicked faq -150px
            window.scrollTo({
                top:
                    this.getBoundingClientRect().top + window.pageYOffset - 250,
                behavior: "smooth",
            });
            //set target to the clicked parent "accordion" div
            const target = this.parentElement;
            //if the target is already open, close it
            if (target.classList.contains("open")) {
                target.classList.remove("open");
            } else {
                target.classList.add("open");
            }
        });
    }

    //add th
});
